'use strict'
loadAsyncJS = require '../../../src/frontend/helper/general/m_loadAsyncJS'

# Groupon.DFPAds:
module.exports = Groupon.DFPAds =
  init: ->
    unless document.head.querySelector("meta[name='dfp-manual']")
      Groupon.DFPAds.load()

  isValidConsentCookie: ->
    c3s = window.Cookie.get('c3s')
    return true unless c3s
    #only return false if regexp /^\d+-\d+-([0-1])$/g is matched, example 123423-2342342-(0|1)
    return c3s.match(/^\d+-\d+-([0-1])$/g) == null

  load: ->
    return unless Groupon.DFPAds.isValidConsentCookie()

    h = document.head
    return unless h.querySelector("meta[name='dfp-slot']") or h.querySelector("meta[name='dfp-target']")

    # decode the meta tag specs for how we should target ads
    googletag.cmd.unshift ->
      read = (s) ->
        s = s.replace(/&#39;/g, "\x27").replace(/&quot;/g, '\x22').
              replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&amp;/g, '&')
        try
          s = JSON.parse(s)
        s

      getAttrs = (metaData, type, names...) ->
        return  unless metaData.name is type
        data = {}
        for name in names
          try data[name] = read metaData.getAttribute "data-#{ name }"
        data

      metatags = h.getElementsByTagName('meta')

      for meta in metatags
        if (data = getAttrs(meta, 'dfp-slot', 'target', 'size', 'div'))
          googletag.defineSlot(data.target, data.size, data.div).addService(googletag.pubads())
        else if (data = getAttrs(meta, 'dfp-target', 'key', 'val'))
          googletag.pubads().setTargeting(data.key, data.val)

      googletag.pubads().enableSingleRequest()
      googletag.pubads().collapseEmptyDivs()
      googletag.enableServices()

    loadAsyncJS '//www.googletagservices.com/tag/js/gpt.js'

